const initDatepicker = () => {
  const datepicker = document.getElementById("birthday");
  if (datepicker) {
    IMask(datepicker, {
      mask: Date,
      min: new Date(1900, 0, 1),
      max: new Date(2100, 0, 1),
    });
    $("#birthday").datepicker();
  }
};

export default initDatepicker;
